// Walid's assets — locally-served WebP for fast LCP on Lighthouse.
// Original PNG sources kept as ALT for any non-critical fallbacks.

// Logo — small PNG (used as CSS mask-image, transparency required)
export const WALID_LOGO = "/img/logo-small.png";

// Hero portrait — multiple sizes for responsive loading
export const WALID_PHOTO_NIGHT = "/img/hero-800.webp";
export const WALID_PHOTO_NIGHT_SRCSET =
    "/img/hero-480.webp 480w, /img/hero-800.webp 800w, /img/hero-1200.webp 1200w";
export const WALID_PHOTO_NIGHT_SIZES =
    "(min-width: 1024px) 540px, (min-width: 768px) 60vw, 90vw";

// Studio portrait — alternative, used on About / minor surfaces
export const WALID_PHOTO_STUDIO = "/img/studio-800.webp";

export const WALID_PHOTO_ALT = WALID_PHOTO_STUDIO;
export const WALID_PHOTO = WALID_PHOTO_STUDIO;
